export default __webpack_public_path__ + "static/media/Kale-Closeup-200px.jpg.469a9832.webp";